import { createSelector } from 'reselect'

export const getData = state => state.reportPallets.getIn(['all', 'objects'])
export const createGetDataSelector = () => createSelector([getData], data => data)
